import { PROD_ORIGIN } from "@/shared/components/Seo/Seo";
/**
 * JSON-LD страницы одним @graph: WebPage + BreadcrumbList + FAQPage (из
 * FAQ-секций — ровно те вопросы, что видны на странице) + доп. узлы конфига.
 * Organization/WebSite уже объявлены в public/index.html — ссылаемся по @id.
 */
export const buildLandingJsonLd = (config) => {
    const url = `${PROD_ORIGIN}${config.path}`;
    const faq = config.sections.flatMap((s) => (s.type === "faq" ? s.items : []));
    const graph = [
        {
            "@type": "WebPage",
            "@id": `${url}#webpage`,
            url,
            name: config.seo.title,
            description: config.seo.description,
            inLanguage: "ru-RU",
            isPartOf: { "@id": `${PROD_ORIGIN}/#website` },
            publisher: { "@id": `${PROD_ORIGIN}/#organization` },
            breadcrumb: { "@id": `${url}#breadcrumb` },
        },
        {
            "@type": "BreadcrumbList",
            "@id": `${url}#breadcrumb`,
            // Главная — сама корень крошек: вторая ступень вела бы на тот же адрес.
            itemListElement: config.path === "/"
                ? [{ "@type": "ListItem", position: 1, name: "Виртуоз", item: `${PROD_ORIGIN}/` }]
                : [
                    { "@type": "ListItem", position: 1, name: "Виртуоз", item: `${PROD_ORIGIN}/` },
                    { "@type": "ListItem", position: 2, name: config.name, item: url },
                ],
        },
    ];
    if (faq.length) {
        graph.push({
            "@type": "FAQPage",
            "@id": `${url}#faq`,
            mainEntity: faq.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
        });
    }
    return { "@context": "https://schema.org", "@graph": [...graph, ...(config.jsonLd ?? [])] };
};
